import * as Yup from 'yup'

const UpdatePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .label('Current Password')
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/g,
      'Current Password must have 10 characters, and must contain 1 capital letter,' +
        ' 1 lowercase letter, 1 special character, and 1 number',
    )
    .required(),
  password: Yup.string()
    .label('New Password')
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/g,
      'New Password must have 10 characters, and must contain 1 capital letter,' +
        ' 1 lowercase letter, 1 special character, and 1 number',
    )
    .required(),
  confirmPassword: Yup.string()
    .label('Confirm Password')
    .min(6, 'Confirm Password is too Short')
    .oneOf([Yup.ref('password'), null], 'Confirm password must match new password!'),
})

export default UpdatePasswordSchema
